import ByodAdapter from './byod';

export default class MetricAdapter extends ByodAdapter {}
